import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export const useApi = ({
  api,
  id,
  params = {},
  skip,
  onLoad,
  passObjectAsArgument = true,
  fetchBeforeMounting = false,
  isProductPage = false
}, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (fetchBeforeMounting) return;
    setData(null);
    fetchData();
  }, [id, ...Object.values(params), skip, fetchBeforeMounting, ...deps]);

  useLayoutEffect(() => {
    if (!fetchBeforeMounting) return;
    setData(null);
    fetchData();
  }, [id, ...Object.values(params), skip, fetchBeforeMounting, ...deps]);

  const fetchData = async () => {
    if (skip) return;
    if (!id && !Object.keys(params).length) return;

    setLoading(true);

    let result;
    if (id) {
      result = await api?.(passObjectAsArgument ? { id } : id, params, isProductPage ? "hideToast" : "");
    } else {
      result = await api?.({ id, ...params });
    }

    if (!isMountedRef.current) return;

    if (result) {
      const item = result.results ? result.results[0] : result;
      setData(item);
      onLoad?.(item);
    }
    setLoading(false);
    setLoaded(true);
  };

  const update = (newData) => {
    setData(newData);
  };

  return {
    data,
    loading,
    refetch: fetchData,
    update,
    loaded,
  };
};
